<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import ModuleIconLabel from "../components/ModuleIconLabel.svelte";
  import P from "../components/P.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps } from "../utils";

  const license = "extension";
  const iconProps = getIconProps("sourcing");
</script>

<Slide>
  <ModuleIconLabel {license} />
  <H1>The AI browser built for recruiters</H1>
  <P>
    Find candidates across your ATS, CRM, job boards, and the web with simple
    prompts — no Boolean, no filters. Search AI turns hours of sourcing into
    minutes.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-magnifying-glass" {...iconProps} />One search bar
      pulls from your ATS/CRM and the wider web
    </Bullet>
    <Bullet>
      <IconScale class="fa-user-plus" {...iconProps} />Revive buried contacts
      and turn data into your top sourcing channel
    </Bullet>
    <Bullet>
      <IconScale class="fa-chart-diagram" {...iconProps} />Find, review, enrich
      and engage candidates all in one flow
    </Bullet>
  </Bullets>
  <CTAs webpageLink="https://sourcewhale.com/sourcing" {license} />
</Slide>
